import { settingsInitialState } from "./settings.types";

export const initialState: settingsInitialState = {
	appReady: false,
	features: {},
	isStoreB2B: false,
	isCrm: false,
	strings: {},
	country: "",
	language: "",
	locale: "",
	areaCode: "",
	storeId: 310,
	privacyPolicyUrl: "",
	vippsLoginLink: "",
	returnUrl: null,
	validationRules: {},
	generalModal: {
		visible: false,
		title: null,
		content: null,
		isHtml: false,
		formattedTitle: null,
		formattedContent: null,
	},
};
